// @flow

import * as React from 'react';

type Props = {
    color: string,
}

const HorizontalLine = (props: Props) => {
    const { color } = props;
    return null;
};

export default HorizontalLine;
